import {
  BodyText,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui";
import { PatientTableRow } from "./PatientTableRow";
import type { PatientSearchResult } from "./network/usePatientSearch";

interface PatientTableProps {
  patients: PatientSearchResult[];
  isLoading?: boolean;
  isError?: boolean;
  includeVisitRfe: boolean;
  visitId?: string;
}

export const PatientTable = ({
  patients,
  isLoading,
  isError,
  includeVisitRfe,
  visitId,
}: PatientTableProps) => {
  const columnCount = includeVisitRfe ? 6 : 5;
  return (
    <Table className="min-w-[800px]">
      <TableHeader>
        <TableRow>
          <TableHead className="w-64">
            <BodyText bold={true} size="sm" textColor="tertiary">
              Name
            </BodyText>
          </TableHead>
          <TableHead className="w-24">
            <BodyText bold={true} size="sm" textColor="tertiary">
              Age & Sex
            </BodyText>
          </TableHead>
          <TableHead className="w-16">
            <BodyText bold={true} size="sm" textColor="tertiary">
              State
            </BodyText>
          </TableHead>
          <TableHead className="w-16">
            <BodyText bold={true} size="sm" textColor="tertiary">
              Partner
            </BodyText>
          </TableHead>
          <TableHead className="w-16">
            <BodyText bold={true} size="sm" textColor="tertiary">
              MRN
            </BodyText>
          </TableHead>
          {includeVisitRfe && (
            <TableHead>
              <BodyText bold={true} size="sm" textColor="tertiary">
                Chief Complaint
              </BodyText>
            </TableHead>
          )}
          <TableHead>
            <span />
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody
        columnCount={columnCount}
        isLoading={isLoading}
        isError={isError}
      >
        {patients?.map((patient) => {
          return (
            <PatientTableRow
              patient={patient}
              key={patient.patientId}
              includeVisitRfe={includeVisitRfe}
              visitId={visitId}
            />
          );
        })}

        {!patients.length && (
          <TableRow>
            <TableCell colSpan={columnCount} className="text-center h-96">
              <BodyText bold={true} size="sm">
                No Patients Found
              </BodyText>
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};
